module.exports = __webpack_public_path__ + "static/assets/markus-spiske-hp86NCu8hok-unsplash.1517d4a3.jpg";